import React from 'react'
import Loader from './Loader'

export default ({ children, loading = false, isOrange = false }) => (
  <div className='overlay-loader'>
    {children}
    {loading && (
      <div className={[ 'overlay-loader__container', isOrange ? 'overlay-loader__container_orange' : 'overlay-loader__container_light' ].join(' ')}>
        <Loader isLight={isOrange} />
      </div>
    )}

    <style>{`
      .overlay-loader {
        position: relative;
      }
      .overlay-loader__container {
        top: 0;
        left: 0;
        z-index: 200;
        position: absolute;

        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        background: rgba(255, 255, 255, .45);
      }

      .overlay-loader__container_light {
        background: rgba(255, 255, 255, .5);
      }
      .overlay-loader__container_orange {
        opacity: .5;
        background: #ff5027;
      }
    `}</style>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/OverlayLoader.jsx